/**
 * Active STT provider switch.
 * Default: assemblyai. Set REACT_APP_STT_PROVIDER=speechmatics to revert.
 */
import assemblyAiService, {
  DEFAULT_SPEAKER_MAP as ASSEMBLY_SPEAKER_MAP,
  mapSpeakerLabel as mapAssemblySpeakerLabel,
} from './assemblyAiService';
import speechmaticsService, {
  DEFAULT_SPEAKER_MAP as SPEECHMATICS_SPEAKER_MAP,
  mapSpeakerLabel as mapSpeechmaticsSpeakerLabel,
} from './speechmaticsService';

export const STT_PROVIDER =
  (process.env.REACT_APP_STT_PROVIDER || 'speechmatics').toLowerCase();

const useAssemblyAi = STT_PROVIDER === 'assemblyai';

const sttService = useAssemblyAi ? assemblyAiService : speechmaticsService;

export const DEFAULT_SPEAKER_MAP = useAssemblyAi
  ? ASSEMBLY_SPEAKER_MAP
  : SPEECHMATICS_SPEAKER_MAP;

export const mapSpeakerLabel = useAssemblyAi
  ? mapAssemblySpeakerLabel
  : mapSpeechmaticsSpeakerLabel;

export { assemblyAiService, speechmaticsService };
export default sttService;
